import React, { useState, useEffect } from "react";
import CurrentRoundRetail from "./CurrentRoundRetail";
import translate from "../../services/Translation/lang";
import rocketmanTransport from "../../services/RocketmanTransport";

export default function CountdownSlider() {
  const initialCountdown = rocketmanTransport?.platformParams?.clicker
    ? 5
    : (rocketmanTransport?.allLoginData?.countdownScreenTime ?? 10);

  const [count, setCount] = useState(initialCountdown);
  const [pulseKey, setPulseKey] = useState(0);

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      if (count > 0) {
        setCount(count - 1);
        setPulseKey(prevKey => prevKey + 1);
      } else {
        clearInterval(countdownInterval);
      }
    }, 1000);

    return () => clearInterval(countdownInterval); 
  }, [count]); 

  useEffect(() => {
    return () => {
      rocketmanTransport.jackpotCurrent([]);
    };
  }, []);

  return (
    <div className="slide countdown-slider">
      <CurrentRoundRetail />
      <div
        key={pulseKey}
        className={"countdown-counter " + (count < 6 ? "pulse-strong red" : " ")}
      >
        {count < 10 ? `0${count}` : count}
      </div>
      <p className="slider-text-big">{translate('hurry_up_and_place_your_bets')}</p>
    </div>
  );
}
